export default "__VITE_ASSET__09cdb589__"